import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import DemandeProjet from './pages/DemandeProjet';
import Contact from './pages/Contact';
import DashboardClient from './pages/DashboardClient';
import DashboardAdmin from './pages/DashboardAdmin';
import DashboardTechnicien from './pages/DashboardTechnicien';
import DashboardCoordinateur from './pages/DashboardCoordinateur';
import ChangerMotDePasse from './pages/ChangerMotDePasse';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/"                        element={<Home />} />
        <Route path="/login"                   element={<Login />} />
        <Route path="/register"                element={<Register />} />
        <Route path="/dashboard"               element={<Dashboard />} />
        <Route path="/dashboard/client"        element={<DashboardClient />} />
        <Route path="/dashboard/admin"         element={<DashboardAdmin />} />
        <Route path="/dashboard/technicien"    element={<DashboardTechnicien />} />
        <Route path="/dashboard/coordinateur"  element={<DashboardCoordinateur />} />
        <Route path="/demande-projet"          element={<DemandeProjet />} />
        <Route path="/contact"                 element={<Contact />} />
        <Route path="/changer-mot-de-passe"    element={<ChangerMotDePasse />} />
      </Routes>
    </Router>
  );
}

export default App;